import { V2_ENDPOINT } from "@/consts";
import { authenticatedFetchJson } from "@/lib/authenticatedFetch";
import type { GetPlanOptionsData } from "@/types/planOptions";
import { useQuery } from "@tanstack/react-query";

interface GetPlanOptionsResponse {
  code: number;
  message: string;
  data: GetPlanOptionsData;
  requestId: string;
}

export const planOptionsKeys = {
  all: ["plan-options"] as const,
  byOrg: (orgId: string) => ["plan-options", orgId] as const,
};

export function usePlanOptions(orgId: string | undefined) {
  return useQuery({
    queryKey: planOptionsKeys.byOrg(orgId ?? ""),
    queryFn: async () => {
      if (!orgId) throw new Error("No orgId");
      const res = await authenticatedFetchJson<GetPlanOptionsResponse>(
        `${V2_ENDPOINT}/v1/organizations/${orgId}/plan-options`,
        { method: "GET", orgId },
      );
      return res.data;
    },
    enabled: !!orgId,
    staleTime: 30_000,
  });
}
